import { create } from "zustand";

export const useAppStore = create((set) => ({
  // Theme
  isDark: true,
  toggleTheme: () => set((state) => ({ isDark: !state.isDark })),

  // Live Metrics (mock data for now - we connect to Puter KV later)
  metrics: {
    tvl: 1245837.42,
    arbProfit: 432.18,
    sentiment: 0.62,
  },
  updateMetrics: (newMetrics) => set({ metrics: newMetrics }),

  // Arb Feed
  arbFeed: [
    { id: 1, action: "Arb captured $4.32 on Uniswap vs SushiSwap", timestamp: Date.now() },
  ],
  addArbEvent: (event) =>
    set((state) => ({ arbFeed: [event, ...state.arbFeed].slice(0, 20) })),

  // User State
  user: null,
  setUser: (user) => set({ user }),
}));